'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'user-tie';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f508';
var svgPathData = 'M224 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM96 128a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zM198.6 304c-12.5 0-22.6 10.1-22.6 22.6 0 6.6 2.9 12.8 7.8 17.1l30 26-30.2 54.4-64.8-103.8c-2.1-3.3-6.2-4.6-9.8-3.2-63.9 26.4-109 89.3-109 162.8l0 24c0 4.4 3.6 8 8 8s8-3.6 8-8l0-24c0-64.4 38-119.9 92.9-145.3L217.2 508.2c1.5 2.3 4 3.8 6.8 3.8s5.3-1.4 6.8-3.8L339.1 334.7C394 360.1 432 415.6 432 480l0 24c0 4.4 3.6 8 8 8s8-3.6 8-8l0-24c0-73.5-45-136.4-109-162.8-3.6-1.5-7.8-.2-9.8 3.2l-64.8 103.8-30.2-54.4 30-26c5-4.3 7.8-10.5 7.8-17.1 0-12.5-10.1-22.6-22.6-22.6l-50.7 0zM224 488.9l-30.7-49.2 30.7-55.3 30.7 55.3-30.7 49.2zM192 326.6c0-3.7 3-6.6 6.6-6.6l50.7 0c3.7 0 6.6 3 6.6 6.6 0 1.9-.8 3.8-2.3 5l-29.7 25.7-29.7-25.7c-1.5-1.3-2.3-3.1-2.3-5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserTie = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;